import { createContext, useContext } from 'react';

import type IPagination from 'interfaces/IPagination';
import type { Webhook, WebhookHistory, WebhookTypes } from 'v2/interfaces/webhook2';

interface IWebhookHistoryContext {
  webhook: Webhook;
  listWebhookHistory: WebhookHistory[];
  loading: boolean;
  id: string;
  type: WebhookTypes;
  product_id: number[];
  pagination: IPagination;
  setPagination: (pagination: IPagination) => void;
  updateList: () => void;
}
const WebhookHistoryContext = createContext<IWebhookHistoryContext>({} as IWebhookHistoryContext);

export function useWebhookHistoryContext() {
  const context = useContext(WebhookHistoryContext);
  return context;
}

export default WebhookHistoryContext;
